export const ALADDIN_PORTFOLIO_BUILDER_API_URL =
  process.env?.AWAPI_ALADDINPORTFOLIOBUILDERSERVER_URL || '/aladdinportfoliobuilder';
export const ALADDIN_PORTFOLIO_BUILDER_API_URL_AGRAPH =
  process.env?.AWAPI_ALADDINPORTFOLIOBUILDERSERVER_URL_AGRAPH || '/api/wealth/legacy/apb-server/v1';
export const CHUNK_SIZE = 90;
